<template>
    <div>
        <div class="header">
            <div class="container">
                <h1>
                    <a class="logo" :href="homeurl">
                        <img src="../../assets/img/logo.png" alt="zfx">
                    </a>
                    <span class="title" id="headerTitle" style="display: inline-block;">{{$store.state.title}}</span>
                </h1>
                <div class="header-btn">
                    <span class="btn-customer" @click="tap_page">MyZFX</span>
                    <router-link class="btn-true" tag="a" :to="{name:'register'}">Live Account</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { logout, isLogin } from 'service/login'
  import { CODE_OK } from '../../utils/const'

  export default {
    data () {
      return {
        homeurl: 'http://www.zfx.co.uk'
      }
    },
    created () {
      var str = location.href
      console.log(str)
      if (str.search('stb') != -1) {
        this.homeurl = 'http://www2.stb.zfx.co.uk'
      }
      if (str.search('beta') != -1) {
        this.homeurl = 'http://www2.beta.zfx.co.uk'
      }
    },
    methods: {
      tap_page () {

        isLogin().then(res => {
          if (res.code !== CODE_OK) {
            this.$router.push({name: 'login'})
          } else {
            this.$router.push({name: 'memberIndex'})
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '@/assets/css/helper/variables.scss';
    @import '@/assets/css/helper/mixin.scss';

    .header {
        height: 82px;
        padding-top: 18px;
        // background-color: #454545;
        background: #fff;
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        h1 {
            float: left;
            // padding-top: 7px;
        }
        .logo {
            display: inline-block;
            vertical-align: middle;
            font-size: 0;
            margin-right: 30px;
        }
        .title {
            vertical-align: middle;
            padding-left: 30px;
            // border-left: 1px solid #fbfbfb;
            border-left: 1px solid #999;
            font-size: 24px;
            line-height: 31px;
            // color: #ffffff;
            color: #333;
        }
        .header-btn {
            float: right;
            span, a {
                display: inline-block;
                height: 46px;
                line-height: 46px;
                text-align: center;
                vertical-align: middle;
                &:hover {
                    background-color: #0A95FF;
                    color: #fff;
                }
            }
        }
        .btn-customer {
            width: 80px;
            color: #0A95FF;
            border: solid 1px #0A95FF;
            @extend %transition;
            margin-right: 10px;
            &:hover {
                background-color: #0A95FF;
                color: #fff;
            }
        }
        .btn-true {
            width: 121px;
            color: #fff;
            background-color: #0A95FF;
            &:hover {
                opacity: 0.9;
            }
        }
    }
</style>
